import { ApiResponse } from "../types";
import { Availability } from "./availabilityManagementApi";
import { apiClient } from "./apiClient";

export interface Professional {
  id: number;
  availability?: Availability[];
  companyId: number;
  name: string;
  email?: string;
  picture?: string;
  isActive?: boolean;
  phoneNumber: string;
  createdAt: string;
  updatedAt: string;
}

export const professionalsApi = {
  // Get all professionals
  async getProfessionals(): Promise<ApiResponse<Professional[]>> {
    try {
      const data = await apiClient.get<any>("/professionals");

      return {
        success: true,
        data: data.data || data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Get professionals by company
  async getProfessionalsByCompany(): Promise<ApiResponse<Professional[]>> {
    try {
      const data = await apiClient.get<any>(
        `/professionals`
      );

      return {
        success: true,
        data: data.data || data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Get professional by ID
  async getProfessionalById(id: number): Promise<ApiResponse<Professional>> {
    try {
      const data = await apiClient.get<any>(`/professionals/${id}`);

      return {
        success: true,
        data: data.data || data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Create a new professional
  async createProfessional(
    professionalData: Omit<Professional, "id" | "createdAt" | "updatedAt" | "companyId">
  ): Promise<ApiResponse<Professional>> {
    try {
      const data = await apiClient.post<any>(
        "/professionals",
        professionalData
      );

      return {
        success: true,
        data: data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Update an existing professional
  async updateProfessional(
    id: number,
    professionalData: Partial<
      Omit<Professional, "id" | "createdAt" | "updatedAt">
    >
  ): Promise<ApiResponse<Professional>> {
    try {
      const data = await apiClient.put<any>(
        `/professionals/${id}`,
        professionalData
      );

      return {
        success: true,
        data: data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Delete a professional
  async deleteProfessional(id: number): Promise<ApiResponse<boolean>> {
    try {
      await apiClient.delete(`/professionals/${id}`);

      return {
        success: true,
        data: true,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Reset professional password
  async resetProfessionalPassword(
    id: number,
    newPassword: string
  ): Promise<ApiResponse<{ message: string }>> {
    try {
      const data = await apiClient.put<any>(
        `/professionals/${id}/password`,
        { newPassword }
      );

      return {
        success: true,
        data: data.data || { message: "Password reset successfully" },
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },
};
